export default __webpack_public_path__ + "static/media/credit-cards 1.5ab8575b.svg";